export const srCommonTranslates = {
  // Party
  createParty: 'Lični podaci',
  personalDetails: 'Lični podaci',
  partyType: 'Tip strane',
  successFillUserData: 'Uspešno popunjeni lični podaci',
  successUpdatedPartyQuestionnaireData: 'Uspešno ažurirani lični podaci',
  firstName: 'Ime',
  lastName: 'Prezime',
  requiredField: 'Obavezno polje',
  questionnaireSet: 'Upitnik',
  EndFilling: 'Završi popunjavanje',
  StartFill: 'Započni popunjavanje',

  // Party case
  SuccessfullySubmittedPartyCase: 'Uspešno poslata prijava strane',
  YourPartyCaseWillBeProcessed: 'Vaša prijava će biti obrađena',

  // Questionnaire fields
  none: 'Nijedno',
  middleName: 'Srednje ime',
  parentName: 'Ime roditelja',
  personalId: 'JMBG',
  dateOfBirth: 'Datum rođenja',
  placeOfBirth: 'Mesto rođenja',
  stateOfBirth: 'Pokrajina rođenja',
  countryOfBirth: 'Država rođenja',
  countryOfIdIssue: 'Država izdavanja dokumenta',
  idNumber: 'Broj ličnog dokumenta',
  idType: 'Tip dokumenta',
  idIssuer: 'Izdavalac dokumenta',
  idDateOfIssue: 'Datum izdavanja',
  idExpiryDate: 'Datum isteka',
  idPermanent: 'Trajni dokument',
  cityOfResidence: 'Grad prebivališta',
  zip: 'Poštanski broj',
  countryOfResidence: 'Država prebivališta',
  mailingAddress: 'Adresa za poštu',
  email: 'Email',
  resident: 'Rezident',
  citizenship: 'Državljanstvo',
  streetName: 'Ulica',
  place: 'Mesto',
  addressType: 'Tip adrese',
  residenceNumber: 'Broj stana/kuće',
  stateOfResidence: 'Pokrajina prebivališta',
  phoneNumber: 'Fiksni telefon',
  mobileNumber: 'Mobilni telefon',
  additionalNote: 'Dodatna napomena',
  maternalName: 'Majčino prezime',
  occupation: 'Zanimanje',

  // PredefinedRegEx enum
  EMAIL: 'Email',
  PHONE: 'Telefon',
  JMBG: 'JMBG',
  REGISTRATION_NUMBER: 'Matični broj',
  VAT_NUMBER: 'PIB',
  WEB_PAGE: 'Veb stranica',
  CUSTOM: 'Prilagođeno',

  // Validation mode enum
  IN_THE_PAST: 'U prošlosti',
  IN_THE_FUTURE: 'U budućnosti',

  // List dynamic source
  SR_CITY_LIST: 'Lista gradova Srbije',
  COUNTRY_LIST: 'Lista država',
  NACE_CODE_LIST: 'Lista NACE kodova',
  BUSINESS_TYPE: 'Tip poslovanja',
  BUSINESS_INDUSTRY: 'Industrija',
  ID_TYPES: 'Tipovi dokumenata',
  ADDRESS_TYPES: 'Tipovi adresa',

  // Question mode enum
  ALL: 'Svi',
  AT_LEAST_ONE: 'Bar jedan',

  // Label mode
  DESCRIPTION: 'Opis',
  TITLE: 'Naslov',
  SUBTITLE: 'Podnaslov',
  TITLE_SUBTITLE: 'Naslov i podnaslov',

  companyName: 'Naziv firme',
  shortName: 'Skraćeni naziv',
  tradeName: 'Poslovno ime',
  typeOfLegalEntity: 'Pravni oblik',
  companyRegistrationNumber: 'Matični broj firme',
  taxNumber: 'PIB',
  registeredActivity: 'Registrovana delatnost',
  registrationDate: 'Datum registracije',
  stateOfRegistration: 'Pokrajina registracije',
  countryOfRegistration: 'Država registracije',
  numberOfYearsInBusiness: 'Godina poslovanja',
  industry: 'Industrija',
  registrationAddress: 'Adresa registracije',
  city: 'Grad',
  postalCode: 'Poštanski broj',
  primaryPhoneNumber: 'Primarni telefon',
  webSite: 'Veb sajt',
  ownerType: 'Tip vlasništva',
  SOLE_PROPRIETORSHIP: 'Preduzetnik',
  PRIVATELY_HELD: 'Privatna firma',
  PUBLICLY_TRADED: 'Akcionarsko društvo',
  GOVERNMENT_OWNED: 'Državno vlasništvo',
  OTHER_HYBRID: 'Drugi hibridni oblik',
  businessType: 'Vrsta delatnosti',
  category: 'Kategorija',
  statisticalGroup: 'Statistička grupa',
  businessTypeOfClient: 'Vrsta delatnosti klijenta',
  businessInvolvedInFollowingIndustries: 'Firma posluje u sledećim industrijama',
  typeOfRelationship: 'Vrsta odnosa',

  AssessmentIsPassed: 'Test je uspešno položen.',
  ErrorNotEnoughPoints: 'Niste osvojili dovoljno poena za prolaz.',
  ErrorNotOnTime: 'Upozorenje! Vreme je isteklo, test je završen.',

  dateMustBeInFuture: 'Datum mora biti u budućnosti',
  dateMustBeInPast: 'Datum mora biti u prošlosti',

  UndefinedIdDocument: 'Nedefinisan dokument',
  ID: 'Lična karta',
  Passport: 'Pasoš',
  Refugee_ID: 'Izbeglički identifikacioni dokument',
  Asylum_Seeker_ID: 'Dokument tražioca azila',
  Refugee_Travel_Document: 'Putna isprava za izbeglice',
  Diplomatic_ID: 'Diplomatski dokument',
  Emergency_Travel_Document: 'Hitna putna isprava',
  Military_Identification_Card: 'Vojna identifikaciona kartica',
  Convict_Identification_Card: 'Zatvorska identifikaciona kartica',
  Foreign_ID: 'Strana lična karta',
  ID_Foreign_Citizen: 'ID stranog državljanina',
  Driving_Licence: 'Vozačka dozvola',
};
